<template>
  <div>
    <RowCard
      :theme="getTheme(item.status)"
      class="align-start py-4"
      style="position: relative; min-height: 71px"
    >
      <div :style="{ width: headers[0].width }" class="flex-center">
        <div class="flex-center gap-4">
          <v-btn
            v-if="showIconNewRound(item)"
            small
            icon
            @click="addNewRound(item.form_fund_group_id)"
          >
            <Iconify
              :key="`new-round-${item.id}-${index}`"
              :icon-ref="iconConfig.newRound.ref"
              :icon="iconConfig.newRound.icon"
              :size="iconConfig.newRound.size"
              :color="iconConfig.newRound.color"
            ></Iconify>
            <!-- <Iconify
              icon="ion:document-text"
              size="15px"
              color="#F15A29"
            ></Iconify> -->
          </v-btn>
          <v-btn
            v-if="showIconDelete(item)"
            small
            icon
            @click="onDelete(item.id)"
          >
            <Iconify
              :key="`delete-${item.id}-${index}`"
              :icon-ref="iconConfig.delete.ref"
              :icon="iconConfig.delete.icon"
              :size="iconConfig.delete.size"
              :color="iconConfig.delete.color"
            ></Iconify>
            <!-- <Iconify
              style="color: #b1b1b1"
              icon="basil:trash-alt-solid"
              size="15px"
            ></Iconify> -->
          </v-btn>
        </div>
      </div>
      <div :style="{ width: headers[1].width }">
        {{ item.no }}
      </div>
      <div :style="{ width: headers[2].width }" class="underline-text">
        {{ item?.id }}
      </div>
      <div :style="{ width: headers[3].width }">
        <div class="one-line" style="height: 20px">
          {{ item?.project_name_th }}
        </div>
      </div>
      <div
        :style="{
          width: headers[4].width,
        }"
      >
        {{ item.department_name }}
      </div>
      <div
        :style="{
          width: headers[5].width,
          color: statusColorSeparator(item.status),
        }"
      >
        {{ item.status }}
      </div>
      <div :style="{ width: headers[6].width }"></div>

      <v-btn
        absolute
        top
        right
        icon
        :class="{ rotate180: isExpanded }"
        @click="seeDetail"
      >
        <Iconify
          :key="`expand-${item.id}-${index}-${isExpanded}`"
          :icon-ref="iconConfig.expand.ref"
          :icon="iconConfig.expand.icon"
          :color="iconConfig.expand.color"
        ></Iconify>
        <!-- <Iconify
          icon="material-symbols:keyboard-arrow-down"
          color="#D3D3D3"
        ></Iconify> -->
      </v-btn>
    </RowCard>

    <div class="expand-layout px-5" :class="[rand]">
      <div class="expand-content">
        <div class="d-flex justify-space-between theme-color-eight">
          <div class="flex-center" style="min-width: 8%; max-width: 8%">
            Action
          </div>
          <div style="min-width: 6%; max-width: 6%"></div>
          <div style="min-width: 13%; max-width: 13%">รอบที่</div>
          <div style="min-width: 34%; max-width: 34%">แก้ไขล่าสุด</div>
          <div style="min-width: 17%; max-width: 17%">ผู้นำเข้าข้อมูล</div>
          <div style="min-width: 17%; max-width: 17%">สถานะ</div>
          <div style="min-width: 5%; max-width: 5%"></div>
        </div>

        <v-divider class="my-3"></v-divider>

        <div v-if="item.sub" class="d-flex flex-column gap-8">
          <div v-for="(x, i) in item.sub" :key="`sub-${item.id}-${i}-${x.round}`">
            <div
              class="d-flex justify-space-between align-center sub-item-text"
            >
              <div
                class="flex-center gap-4"
                style="min-width: 8%; max-width: 8%"
              >
                <v-btn
                  v-if="x.status !== 'Draft'"
                  small
                  icon
                  @click="previewFundamental"
                >
                <Iconify 
                    :key="`view-${item.id}-${i}-${x.round}`"
                    :icon-ref="`view-${item.id}-${i}-${x.round}}`"
                    :icon="iconConfig.view.icon" 
                    :size="iconConfig.view.size"
                    :color="iconConfig.view.color"
                  ></Iconify>
                  <!-- <Iconify icon="carbon:view-filled" size="15px"></Iconify> -->
                </v-btn>
                <v-btn v-if="x.status === 'Draft'" small icon @click="onEdit">
                  <v-icon color="#F15A29" size="15px"> mdi-pencil </v-icon>
                </v-btn>
              </div>
              <div style="min-width: 6%; max-width: 6%"></div>
              <div style="min-width: 13%; max-width: 13%">
                {{ x?.round }}
              </div>
              <div style="min-width: 34%; max-width: 34%">
                {{ toDateTimeFormat(x?.updated_at) }}
              </div>
              <div style="min-width: 17%; max-width: 17%">
                {{ x?.reporter_name }}
              </div>
              <div class="sub-status" :style="{
                  minWidth: '17%',
                  maxWidth: '17%',
                  color: statusColorSeparator(x?.status),
                }"
              >
                {{ x?.status }}
              </div>
              <div style="min-width: 5%; max-width: 5%"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "./input/Button";
import RowCard from "../components/RowCard";
import { toDateRangeFormat, toDateTimeFormat } from "../plugins/global-funcs";

export default {
  name: "ProgressFundamentalItem",
  components: {
    Button,
    RowCard,
  },
  props: {
    item: {
      default: () => ({}),
    },
    index: {
      default: 0,
    },
    headers: {
      default: () => [],
    },
  },
  data() {
    return {
      toDateRangeFormat,
      toDateTimeFormat,
      rand: "cl-" + Math.random().toString().slice(2),
      theme: 2,
      redText: false,
      isExpanded: false,
      iconConfig: {
      newRound: {
        icon: "ion:document-text",
        size: "15px", 
        color: "#F15A29"
      },
      delete: {
        icon: "basil:trash-alt-solid",
        size: "15px",
        color: "#b1b1b1"
      },
      expand: {
        icon: "material-symbols:keyboard-arrow-down",
        color: "#D3D3D3"
      },
      view: {
        icon: "carbon:view-filled",
        size: "15px",
        color: "#666666"
      }
    }
    };
  },
  methods: {
    seeDetail() {
      let growDiv = document.querySelector("." + this.rand + ".expand-layout");
      if (growDiv.clientHeight) {
        growDiv.style.height = 0;
        this.isExpanded = false;
      } else {
        let wrapper = document.querySelector(
          "." + this.rand + " .expand-content"
        );
        growDiv.style.height = wrapper.clientHeight + 20 + "px";
        this.isExpanded = true;
      }
    },
    onEdit() {
      this.$router.push({
        name: "ProgressFundamentalForm",
        query: { id: this.item.id },
      });
    },
    previewFundamental() {
      this.$router.push({
        name: "ProgressFundamentalForm",
        query: { id: this.item.id, preview: true },
      });
    },
    addNewRound(form_fund_group_id) {
      this.$router.push({
        name: "ProgressFundamentalForm",
        query: { id: this.item.id ,groupId: form_fund_group_id },
      });
    },
    onDelete(id) {
      console.log(id);
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("Fundamental/deleteFundamental", id);
          console.log("delete!!!", res);
          if (res) {
            window.location.reload();
          }
        },
      });
    },
    statusColorSeparator(status) {
      switch (status) {
        case "Draft":
          this.redText = true;
          return "var(--theme-color-one)";

        case "Submitted":
          return "var(--theme-color-three)";

        default:
          return "var(--theme-color-two)";
      }
    },
    getTheme(status) {
      switch (status) {
        case "Draft":
          return 2;
        case "Submitted":
          return 5;
        default:
          return 1;
      }
    },

    showIconNewRound(item) {
      return item.status === "Submitted";
    },
    showIconDelete(item) {
      if (item.sub && item.sub.length > 0) {
        // first item have status 'Draft'
        return item.sub[0].status === "Draft";

        // other case, last item have status 'Draft'
        // return item.sub[item.sub.length - 1].status === "Draft";
      } else {
        return false; // if no sub items, do not allow delete
      }
    },
  },
};
</script>

<style scoped>
.left-side {
  min-width: 40px;
  max-width: 40px;
}

.btn-pos {
  position: absolute;
  bottom: 24px;
  right: 24px;
}

.expand-layout {
  -moz-transition: height 0.2s;
  -ms-transition: height 0.2s;
  -o-transition: height 0.2s;
  -webkit-transition: height 0.2s;
  transition: height 0.2s;
  height: 0;
  overflow: hidden;
}
.expand-content {
  padding: 24px;
  background: #fafafa;
  box-shadow: 1px 1px 20px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 20px 20px;
}
.underline-text {
  text-decoration: underline;
}

.sub-item-text {
  color: black;
  font-size: 12px;
  font-weight: 500;
}

.sub-status {
  color: var(--theme-color-three);
  font-size: 14px;
  font-weight: 500;
}

.rotate180 {
  transform: rotate(180deg);
  transition: transform 0.2s ease;
}
</style>
